export default __webpack_public_path__ + "static/media/LogoMyBook.ba2dbe57.png";